import { IMember } from "@wingspanhq/users";

export const selectorMemberCompany = (member: IMember) =>
  member.profile.company?.name || member.profile.company?.legalBusinessName;
